import { useCallback } from "react";
import { User } from "@/models/user";
import { AuthService } from "@/services/auth/auth.service";
import { redirectToLoginPage } from "@/utils/redirectToLoginPage";

function useAuth() {
  const { data, error, isLoading } = AuthService.getUserInfo();

  const isAdmin = ["admin", "superadmin"].includes(data?.role ?? "");

  // ログアウト
  const logout = useCallback(async (): Promise<void> => {
    try {
      await AuthService.logout();
    } catch (error) {
      console.error("Logout hook encountered an error", error);
    } finally {
      redirectToLoginPage();
    }
  }, []);

  return {
    authUser: data
      ? new User(data.id, data.name, data.email, data.role)
      : undefined,
    error,
    isLoading,
    isAdmin,
    logout,
  };
}

export default useAuth;
